import { ReminderBranchDetailsOutput } from './reminder-branch-details-output.model';
import { ReminderVehicleDetailsOutput } from './reminder-vehicle-details-output.model';
import { ReminderUserGroupOutput } from './reminder-user-group-output.model';
import { ReminderSmsOutput } from './reminder-sms-output.model';
import { ReminderEmailOutput } from './reminder-email-output.model';


export class ReminderWithOutStatusOutputData implements IReminderWithOutStatusOutputData {
    /** The auto-generated id of the reminder master */
    reminder_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The branch type must be one of "All" or "Select" */
    branch_type!: string;
    /** The vehicle type must be one of "All" or "Selected" */
    vehicle_type!: string;
    /** The vehicle type must be one of "All" or "Selected" */
    user_type!: string;
    /** The auto-generated id of the maintenance master */
    maintenance_type_id!: number;
    /** The every month */
    every_month!: number;
    /** The every distance */
    every_distance!: number;
    /** The notify before days */
    notify_before_days!: number;
    /** The notify before distance */
    notify_before_distance!: number;
    /** The description with 5000 character */
    description!: string;
    /** The notification repeat should be Never or Daily */
    notification_repeat!: string;
    /** The notification time */
    notification_time!: string;
    /** The mobile app */
    mobile_app!: number;
    /** The sms */
    sms!: number;
    /** The sms */
    email!: number;
    /** The branch detailId */
    branch_detail_Id!: string;
    reminder_branch_data!: ReminderBranchDetailsOutput[];
    reminder_vehicle_details!: ReminderVehicleDetailsOutput[];
    reminder_user_id!: ReminderUserGroupOutput[];
    reminder_sms!: ReminderSmsOutput[];
    reminder_email!: ReminderEmailOutput[];
    status!: number;

    constructor(data?: IReminderWithOutStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder_id = _data["reminder_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_type = _data["branch_type"];
            this.vehicle_type = _data["vehicle_type"];
            this.user_type = _data["user_type"];
            this.maintenance_type_id = _data["maintenance_type_id"];
            this.every_month = _data["every_month"];
            this.every_distance = _data["every_distance"];
            this.notify_before_days = _data["notify_before_days"];
            this.notify_before_distance = _data["notify_before_distance"];
            this.description = _data["description"];
            this.notification_repeat = _data["notification_repeat"];
            this.notification_time = _data["notification_time"];
            this.mobile_app = _data["mobile_app"];
            this.sms = _data["sms"];
            this.email = _data["email"];
            this.branch_detail_Id = _data["branch_detail_Id"];
            if (Array.isArray(_data["reminder_branch_data"])) {
                this.reminder_branch_data = [] as any;
                for (let item of _data["reminder_branch_data"])
                    this.reminder_branch_data!.push(ReminderBranchDetailsOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_vehicle_details"])) {
                this.reminder_vehicle_details = [] as any;
                for (let item of _data["reminder_vehicle_details"])
                    this.reminder_vehicle_details!.push(ReminderVehicleDetailsOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_user_id"])) {
                this.reminder_user_id = [] as any;
                for (let item of _data["reminder_user_id"])
                    this.reminder_user_id!.push(ReminderUserGroupOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_sms"])) {
                this.reminder_sms = [] as any;
                for (let item of _data["reminder_sms"])
                    this.reminder_sms!.push(ReminderSmsOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_email"])) {
                this.reminder_email = [] as any;
                for (let item of _data["reminder_email"])
                    this.reminder_email!.push(ReminderEmailOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ReminderWithOutStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderWithOutStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder_id"] = this.reminder_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_type"] = this.branch_type;
        data["vehicle_type"] = this.vehicle_type;
        data["user_type"] = this.user_type;
        data["maintenance_type_id"] = this.maintenance_type_id;
        data["every_month"] = this.every_month;
        data["every_distance"] = this.every_distance;
        data["notify_before_days"] = this.notify_before_days;
        data["notify_before_distance"] = this.notify_before_distance;
        data["description"] = this.description;
        data["notification_repeat"] = this.notification_repeat;
        data["notification_time"] = this.notification_time;
        data["mobile_app"] = this.mobile_app;
        data["sms"] = this.sms;
        data["email"] = this.email;
        data["branch_detail_Id"] = this.branch_detail_Id;
        if (Array.isArray(this.reminder_branch_data)) {
            data["reminder_branch_data"] = [];
            for (let item of this.reminder_branch_data)
                data["reminder_branch_data"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_vehicle_details)) {
            data["reminder_vehicle_details"] = [];
            for (let item of this.reminder_vehicle_details)
                data["reminder_vehicle_details"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_user_id)) {
            data["reminder_user_id"] = [];
            for (let item of this.reminder_user_id)
                data["reminder_user_id"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_sms)) {
            data["reminder_sms"] = [];
            for (let item of this.reminder_sms)
                data["reminder_sms"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_email)) {
            data["reminder_email"] = [];
            for (let item of this.reminder_email)
                data["reminder_email"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IReminderWithOutStatusOutputData {
    /** The auto-generated id of the reminder master */
    reminder_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The branch type must be one of "All" or "Select" */
    branch_type: string;
    /** The vehicle type must be one of "All" or "Selected" */
    vehicle_type: string;
    /** The vehicle type must be one of "All" or "Selected" */
    user_type: string;
    /** The auto-generated id of the maintenance master */
    maintenance_type_id: number;
    /** The every month */
    every_month: number;
    /** The every distance */
    every_distance: number;
    /** The notify before days */
    notify_before_days: number;
    /** The notify before distance */
    notify_before_distance: number;
    /** The description with 5000 character */
    description: string;
    /** The notification repeat should be Never or Daily */
    notification_repeat: string;
    /** The notification time */
    notification_time: string;
    /** The mobile app */
    mobile_app: number;
    /** The sms */
    sms: number;
    /** The sms */
    email: number;
    /** The branch detailId */
    branch_detail_Id: string;
    reminder_branch_data: ReminderBranchDetailsOutput[];
    reminder_vehicle_details: ReminderVehicleDetailsOutput[];
    reminder_user_id: ReminderUserGroupOutput[];
    reminder_sms: ReminderSmsOutput[];
    reminder_email: ReminderEmailOutput[];
    status: number;
}

